import { useLocation } from "react-router-dom";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useState } from "react";
import { useSTPWeeksBySTPData } from "./hooks/useSTP";
import { FaEdit } from "react-icons/fa";
import STPViewEditModal from "./components/StpViewEditModal";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";

const StpColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Week",
    selector: (row: { Week: string | number }) => row.Week || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Day",
    selector: (row: { Day: string }) => row.Day || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Territory Name",
    selector: (row: { TerritoryName: string }) => row.TerritoryName || "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Beat Name",
    selector: (row: { BeatName: string }) => row.BeatName || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Created At",
    selector: (row: { CreatedAt: string }) => row.CreatedAt || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Updated At",
    selector: (row: { UpdatedAt: string | any }) => row?.UpdatedAt || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center">
        <button
          onClick={() => {
            handleEdit(row);
          }}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
    width: "150px",
    // wrap: true
  },
];

const dataOfTable = [
  {
    Week: "Week 1",
    day: "Monday",
    beat_name: "Beat A",
    territory_name: "North Zone",
    created_on: "01 Jan 2025",
  },
  {
    Week: "Week 1",
    day: "Tuesday",
    beat_name: "Beat B",
    territory_name: "East Zone",
    created_on: "02 Jan 2025",
  },
  {
    Week: "Week 2",
    day: "Wednesday",
    beat_name: "Beat C",
    territory_name: "South Zone",
    created_on: "08 Jan 2025",
  },
  {
    Week: "Week 2",
    day: "Thursday",
    beat_name: "Beat D",
    territory_name: "West Zone",
    created_on: "09 Jan 2025",
  },
  {
    Week: "Week 3",
    day: "Friday",
    beat_name: "Beat E",
    territory_name: "Central Zone",
    created_on: "17 Jan 2025",
  },
];
const STPView: React.FC = () => {
  const location = useLocation();
  const { stpRowData } = location?.state || {};
  const [paginationStates, setPaginationStates] = useState<any>({
    length: 10,
    start: 1,
    search: null,
    sortOrder: "ASC",
    sortColumn: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>("");
  const { data } = useSTPWeeksBySTPData({
    id: Number(stpRowData?.StpId),
    enable: stpRowData?.StpId ? true : false,
    params: {
      start: paginationStates.start,
      length: paginationStates.length,
      search: paginationStates.search,
      sortOrder: paginationStates.sortOrder,
      sortColumn: paginationStates.sortColumn,
    },
  });
  console.log("dTTTT", data?.data);
  // return(
  //   <div>

  //   </div>
  // )

  const handleEdit = (row: any) => {
    console.log("row", row);
    setRowData(row);
    setCheckAddEditStatus("Edit");
    // setIsModalOpen(true)
    toggleModal()
  };
  const toggleModal = () => {
    // setCheckAddEditStatus('Add')
    setIsModalOpen(!isModalOpen);
  };
  const handlePagination = (pageNo: number) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  // console.log('dataOfFieldssss', data?.data)

  return (
    <div className="p-4">
      <PageHeader
        title="STP"
        buttons={
          [
            // {
            //     label: "+ Add Subscriber Field",
            //     onClick: toggleModal,
            //     color: "#2e8dd3",
            // },
          ]
        }
      />
      <BasicDataTable
        paginationTotalRows={data?.data?.recordsTotal || 0}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="STP Details"
        columns={StpColumns(handleEdit)}
        data={data?.data?.data || []}
      />
      <RouteModal
         isOpen={isModalOpen}
        toggle={toggleModal}
        title={"Edit STP View"}
        size="md"
        content={
      <STPViewEditModal
        rowData={{ ...stpRowData, rowData }}
        setIsModalOpen={setIsModalOpen}
        
      />
        }
        />
    </div>
  );
};

export default STPView;
